import { Card } from "antd";
import styled from "styled-components";

export const CardItem: typeof Card = styled(Card)`
  display: flex;
  height: 395px;
  flex: 0 1 33%;
  overflow: hidden;
  flex-direction: column;
  border-radius: 15px;
  background: #ffffff;
`;
export const CardItemWithOverflow: typeof Card = styled(Card)`
  display: flex;
  height: 395px;
  flex: 0 1 33%;
  overflow-y: auto;
  overflow-x: hidden;
  flex-direction: column;
  border-radius: 15px;
  background: #ffffff;
`;

export const CardTitle = styled.div`
  display: flex;
  font-family: Nunito;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
`;
